import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { fetchErrorResponseFromBadRequestPipe } from './error.response';

@Injectable()
export class VouchersService {

  idToken: string;
  apiUrl: string = '/api/vouchers';

  constructor(
    private httpClient: HttpClient) {
  }

  me(): Observable<string[]> {
    return this.httpClient.get<string[]>(`${this.apiUrl}/get-user-roles`);
  }

  getVouchers(startDateFrom: Date, startDateTo: Date, includeExpired: boolean): Observable<IGetVouchersResponse> {
    let url = `${this.apiUrl}/get-vouchers?StartDateFrom=${startDateFrom.toJSON()}&StartDateTo=${startDateTo.toJSON()}&IncludeExpired=${includeExpired}`;


    return this.httpClient.get<IGetVouchersResponse>(url)
      .pipe(fetchErrorResponseFromBadRequestPipe());
  }

  createVoucher(voucherRequest: IVoucherRequest): Observable<void> {
    return this.httpClient.put<void>(`${this.apiUrl}/create-voucher`, voucherRequest)
      .pipe(fetchErrorResponseFromBadRequestPipe());
  }

  voidVoucher(voucherCode:string): Observable<void> {
    return this.httpClient.post<void>(`${this.apiUrl}/void-voucher/${voucherCode}`, null)
      .pipe(fetchErrorResponseFromBadRequestPipe());
  }

  buildUploadValidate(vouchersCsvFile: FileParameter): Observable<IBulkVoucherValidationResponse> {
    let content = new FormData();
    content.append("vouchersCsvFile", vouchersCsvFile.data, vouchersCsvFile.fileName ? vouchersCsvFile.fileName : "vouchersCsvFile");

    return this.httpClient.post<IBulkVoucherValidationResponse>(`${this.apiUrl}/bulk-upload-validate`, content);
  }

  buildUpload(vouchersCsvFile: FileParameter): Observable<void> {
    let content = new FormData();
    content.append("vouchersCsvFile", vouchersCsvFile.data, vouchersCsvFile.fileName ? vouchersCsvFile.fileName : "vouchersCsvFile");

    return this.httpClient.post<void>(`${this.apiUrl}/bulk-upload`, content);
  }
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface IBulkVoucherValidationResponse {
  voucherCount: number;
  validationMessages?: IBulkVoucherValidationMessage[] | undefined;
}

export interface IBulkVoucherValidationMessage {
  message?: string | undefined;
  type: MessageType;
  code?: string | undefined;
  emailAddress?: string | undefined;
}

export enum MessageType {
  Error = 0,
  Warning = 1,
}

export interface IGetVouchersResponse {
  vouchers?: IGetVoucherResponseModel[] | undefined;
}

export interface IGetVoucherResponseModel {
  code?: string | undefined;
  amount: number;
  currency: string;
  startDate: string;
  endDate: string;
  status: ECommerceItemStatus | undefined | null;
  category: string;
  createdBy: string;
  voidedBy: string;
  isPromotional: boolean;
  reference: string;
}

export enum ECommerceItemStatus {
  Empty = 0,
  Reserved = 1,
  Booked = 2,
  Unconfirmed = 3,
  Cancelled = 4,
  Expired = 5,
  Failed = 6,
  Released = 7,
  Voided = 8,
}

export interface IVoucherRequest {
  voucherCode?: string | undefined;
  category: string;
  reference: string;
  isPromotional: boolean;
  amount: number;
  currency: string;
  startDate: Date;
  endDate: Date;
  voucherEligibleAccommodation: boolean;
  voucherUsers?: IVoucherUser[] | undefined;
}

export interface IVoucherUser {
  email?: string | undefined;
}
